<template>
  <div>
    <!-- Main -->
    <div class="d-md-flex h-md-100 align-items-center">
      <div class="col-md-7 p-0 bg-indigo h-md-100 logoarea">
        <div
          class="text-white d-md-flex align-items-center h-100 p-5 text-center justify-content-center"
        >
          <div class="pt-5 pb-5"></div>
        </div>
      </div>
      <div class="col-md-5 p-0 bg-white h-md-100 loginarea">
        <div class="d-md-flex col-12 align-top">
          <img
            src="@/resources/img/ktb-logo.png"
            width="152"
            height="56"
            style="padding-top: 10px;"
          />
          <img src="@/resources/img/h_elg.jpg" width="284" height="58" />
          <router-link to="Login"
            ><img src="@/resources/img/login.jpg" width="59" height="58"
          /></router-link>
        </div>

        <div class="align-items-center h-md-100 p-5 justify-content-center">
          <form class="rounded p-5">
            <div class="form-group material-form">
              <input
                required
                v-model="username"
                type="text"
                placeholder="Username"
                class="form-control"
                @input="username = $event.target.value.toUpperCase()"
                @keyup.enter="login()"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="have-text" for="usernameLogin"
                >ชื่อรหัสผู้ใช้</label
              >
            </div>
            <div class="form-group material-form">
              <label class="have-text" for="passwordLogin">รหัสผ่าน</label>
              <input
                required
                v-model="password"
                type="password"
                placeholder="Password"
                class="form-control"
                autocomplete="off"
                @keyup.enter="login()"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
            </div>

            <div class="form-group material-form">
              <a @click="toggle = !toggle">2FA</a>
              <div v-show="!toggle">
                <input
                  required
                  v-model="fa2"
                  type="fa2"
                  placeholder="2FA"
                  class="form-control"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
              </div>
            </div>

            <button
              type="button"
              @click="login()"
              class="btn btn-info btn-round btn-block shadow-sm"
            >
              เข้าสู่ระบบ
            </button>
          </form>
        </div>
      </div>
    </div>
    <!-- End Main -->

    <footer class="ft-content space-up">
      <div class="container">
        <div class="row">
          <div class="col-6 text-left">
            <i class="feather-icon icon-phone"></i>
            <span>02-111-1111, 02-111-9999 KTB Call Center</span>
          </div>

          <div class="col-6 text-right">
            <span class="text-red"
              >การทำรายการหลังเวลา 15.00 น.
              ถือว่าเป็นการทำรายการของวันทำการถัดไป</span
            ><br />
            <i class="fa fa-copyright"></i>
            <span>สงวนสิทธิ์ พ.ศ. 2562 บมจ. ธนาคารกรุงไทย</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { AUTH_REQUEST } from "@/store/actions/auth";

export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      fa2: "",
      toggle: true,
    };
  },
  methods: {
    login: function() {
      const { username, password, fa2 } = this;

      this.loader = this.$loading.show();

      this.$store
        .dispatch(AUTH_REQUEST, { username, password, fa2 })
        //.then(() => {
        .then((resp) => {
          if (
            resp.data.statusCode != "" &&
            resp.data.statusCode !== null &&
            resp.data.statusCode == "0000"
          ) {
            this.loader.hide();
            if (this.$store.getters.authStatus === "successFirst") {
              this.$router.push("/changePassword");
            } else {
              this.$router.push("/disclaimer");
            }
          } else {
            this.loader.hide();
            this.$swal(
              " ",
              "ไม่สามารถเข้าสู่ระบบได้ : " + resp.data.statusDesc,
              "error"
            );
          }
        })
        .catch((err) => {
          this.loader.hide();
          this.$swal(" ", "ไม่สามารถเข้าสู่ระบบได้ : " + err.message, "error");
        });
    },
  },
};
</script>
